import _ from 'lodash';
import dtm from 'scripts/services/dtm';

export function sendMerchandiseUnitClickAnalitycs(productUrl) {
    if (!productUrl) {
        return;
    }

    dtm.trackMerchandiseUnitClick(productUrl);
}
